import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const createRseeDiscountRequest = reqObject => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.rseeDiscounts
      .createRseeDiscountRequest(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.CREATE_RSEE_DISCOUNT_REQUEST_FAILED,
            reject: actionTypes.CREATE_RSEE_DISCOUNT_REQUEST_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.CREATE_RSEE_DISCOUNT_REQUEST_LOADING);
  const success = res => action(actionTypes.CREATE_RSEE_DISCOUNT_REQUEST_SUCCESS, res);

  return request();
};

export const getMyRseeDiscountsList = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.rseeDiscounts
        .getMyRseeDiscountsList(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_MY_RSEE_DISCOUNTS_LIST_FAILED,
              reject: actionTypes.GET_MY_RSEE_DISCOUNTS_LIST_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_MY_RSEE_DISCOUNTS_LIST_LOADING);
  const success = res => action(actionTypes.GET_MY_RSEE_DISCOUNTS_LIST_SUCCESS, res);

  return request();
};


export const fetchAllRseeDiscountRequests = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.rseeDiscounts
        .fetchAllRseeDiscountRequests(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUESTS_FAILED,
              reject: actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUESTS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUESTS_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUESTS_SUCCESS, res);

  return request();
};


export const fetchAllRseeDiscountRequestArchives = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.rseeDiscounts
        .fetchAllRseeDiscountRequestArchives(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_FAILED,
              reject: actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_SUCCESS, res);

  return request();
};


export const fetchRseeDiscountRequestDetailsById = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.rseeDiscounts
        .fetchRseeDiscountRequestDetailsById(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_RSEE_DISCOUNT_REQUEST_BY_ID,
              reject: actionTypes.FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_LOADING);
  const success = res => action(actionTypes.FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_SUCCESS, res);

  return request();
};

export const updateRseeDiscountRequestStatus = (id, status, rejectionReason) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.rseeDiscounts
        .updateRseeDiscountRequestStatus(id, status, rejectionReason)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_RSEE_DISCOUNT_REQUEST_FAILED,
              reject: actionTypes.UPDATE_RSEE_DISCOUNT_REQUEST_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_RSEE_DISCOUNT_REQUEST_LOADING);
  const success = res => action(actionTypes.UPDATE_RSEE_DISCOUNT_REQUEST_SUCCESS, res);

  return request();
};


export const activateRseeDiscount = (id) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.rseeDiscounts
        .activateRseeDiscount(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.ACTIVATE_RSEE_DISCOUNT_FAILED,
              reject: actionTypes.ACTIVATE_RSEE_DISCOUNT_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.ACTIVATE_RSEE_DISCOUNT_LOADING);
  const success = res => action(actionTypes.ACTIVATE_RSEE_DISCOUNT_SUCCESS, res);

  return request();
};

export const clearCreateDiscountRequestForm = _ => {
  return action(actionTypes.CLEAR_CREATE_RSEE_DISCOUNT_REQUEST_FORM);
};
